import DashboardCard from "../../../ui/DashboardCard/DashboardCard";
import type { TeenDashboardRequestedGigItemResponse } from "../../../../types/teenDashboardTypes";
import { formatGigCrewSummary } from "../../../../utils/GigCrewUtils";
import { requestedGigStatusLabel, requestedGigStatusPillClassName, toReadableDate } from "../shared/dashboardDisplay";

type TeenRequestedGigsBoxProps = {
  gigs: TeenDashboardRequestedGigItemResponse[];
  loading: boolean;
};

const TeenRequestedGigsBox = ({ gigs, loading }: TeenRequestedGigsBoxProps) => {
  return (
    <DashboardCard title="Gigs Applied For" subtitle="Applied gigs and approval progress." to="/teen/gigs">
      {loading ? (
        <p className="text-sm text-myteengig-text-muted">Loading gigs applied for...</p>
      ) : gigs.length === 0 ? (
        <p className="text-sm text-myteengig-text-muted">No gigs applied for yet.</p>
      ) : (
        <ul className="space-y-3">
          {gigs.map((gig) => (
            <li key={gig.gigRequestId} className="rounded-lg border border-myteengig-border bg-myteengig-background p-3">
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <p className="min-w-0 font-semibold text-myteengig-text-primary">{gig.gigTitle ?? "Untitled Gig"}</p>
                <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${requestedGigStatusPillClassName[gig.status]}`}>
                  {requestedGigStatusLabel[gig.status]}
                </span>
              </div>
              <p className="mt-1 text-xs font-medium text-myteengig-text-primary">{formatGigCrewSummary(gig)}</p>
              <p className="mt-1 text-sm text-myteengig-text-muted">Applied {toReadableDate(gig.requestedAt)}</p>
            </li>
          ))}
        </ul>
      )}
    </DashboardCard>
  );
};

export default TeenRequestedGigsBox;
